export const ROTA_SOLICITACAO_PLACA = "/backoffice/solicitacao-placa";
export const ABA_SOLICITACOES = "solicitacoes";
export const ABA_LOTES = "lotes";
